export const setPurchaseListState = (payload) => {
    return {
        type: "SET_PURCHASE_LIST_STATE",
        payload
    };
};

export const clearPurchaseListState = () => {
    return {
        type: "CLEAR_PURCHASE_LIST_STATE"
    };
};